<template>
  <div>
    <!-- <v-badge left overlap>
      <template v-if="notificationListOpen == false" v-slot:badge>
        <div> {{ totalUnseenNotifications }}</div>
      </template>

      <v-flex
        xs-11
        v-show="notificationListOpen == true" 
        class="content-notifications"
      >
        <NotificationsList v-on:isClosed="closeNotifications"/>
      </v-flex>

      <v-flex xs-1 class="aling-buttons">
        <v-btn
          v-show="!hidden"
          id="btnTop"
          ref="button"
          color="#211850"
          @click="closeNotifications"
          dark
          fab
        >
        <v-img
          src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/campana-icon.png">
        </v-img>
        </v-btn>
      </v-flex>
    </v-badge> -->
  </div>
</template>
<script>
// import Vue from "vue";
// import axios from "axios";
// import { mapMutations, mapState, mapActions, mapGetters } from "vuex";
// import NotificationsList from "@/components/Notifications/NotificationsList";
// import ActionCableVue from "actioncable-vue";

// Vue.use(ActionCableVue, {
//   debug: true,
//   debugLevel: "error",
//   connectionUrl: "wss://miapp.security.cl/cable",
//   connectImmediately: true,
// });

export default {
  // components: {
  //   // NotificationsList,
  // },
  data() {
    return {
      // notificationListOpen: false,
      // hidden: false,
      // page: 1
    };
  },
  channels: {
      NotificationChannel: {
      connected() {
      },
      rejected() {},
      received(data) {
        if (this.current_user.profiles.includes(data.profile_id)){
          this.setNotification(data)
          // sumar 1 las notificaciones no vistas
          this.addTotalUnseenNotifications(data)
        }
      },
      disconnected() {
      },
    },
  },
  methods: {
    // ...mapActions("notifications", ["fetchNotifications"]),
    // ...mapMutations("notifications", ["updateNotification", "setNotification", "addTotalUnseenNotifications"]),

    // closeNotifications() {
    //   this.notificationListOpen = !this.notificationListOpen
    // },
    // sendMessage: function () {
    //   this.$cable.perform({
    //     channel: "NotificationChannel",
    //     action: "send_message",
    //     data: {
    //       content: this.message,
    //     },
    //   });
    // },
  },
  // async mounted(){
  //     this.$cable.subscribe({
  //       channel: "NotificationChannel",
  //       // user_id: this.current_user.id,
  //       room: "public",
  //     });
  //     this.fetchNotifications(1)
  //   },
  //   computed: {
  //     ...mapState("user", ["current_user"]),
  //     ...mapState("notifications", ["totalUnseenNotifications"]),
  // },
};
</script>
<style>
.content-notifications{
  width: 700px;
}
.aling-buttons{
  text-align: end;
}
</style>